import app from '@/main';
import Vue from 'vue';
import * as ENDPOINTS from './endpoints';
import { resolveRequestError } from '@/utils/auth';

import { CloseTradeEnum } from '@/enums';

export default class StoresService {

  // ================= function to load trades and withdrawal summary ===================//

  static async loadTradesWithdrawalSummary() {

    try {
      const { data } = await Vue.http.get(ENDPOINTS.GIFTCARD_TRADES_SUMMARY);
      return data
    } catch (error) {
      resolveRequestError(error);
    }
  }

  // ================= function to load income and outload data ===================//

  static async loadIncomeOutcome({ from, to }) {

    try {
      const { data } = await Vue.http.get(ENDPOINTS.GIFTCARD_INCOME_OUTCOME,{
        params: {
          from,
          to
        }
      });

      return data;
    } catch (error) {
      resolveRequestError(error);
    }
  }


  // ================= function to upload terms and conditions ===================//

  static async uploadTerms(term) {

    try {
      const { data } = await Vue.http.post(ENDPOINTS.GIFTCARD_TERMS, term);

      return data
    } catch (error) {
      resolveRequestError(error);
    }
  }


  // ================= function to delete terms and conditions ===================//

  static async deleteTerms(id) {

    try {
      const { data } = await Vue.http.patch(ENDPOINTS.GIFTCARD_TERMS + "?id=" + id);

      return data
    } catch (error) {
      resolveRequestError(error);
    }
  }

  
  // ================= function to edit terms and conditions ===================//

  static async editTerm(term) {

    try {
      const { data } = await Vue.http.put(ENDPOINTS.GIFTCARD_TERMS , term);

      return data
    } catch (error) {
      resolveRequestError(error);
    }
  }

  // ================= function to load gift card trades info ===================//

  static async loadTopCards(status) {

    try {
      const { data } = await Vue.http.get(ENDPOINTS.TOP_CARDS, {
        params: {
          status
        }
      });

      return data
    } catch (error) {
      resolveRequestError(error);
    }
  }

  // ================= function to load top traders ===================//

  static async loadTopTraders() {

    try {
      const { data } = await Vue.http.get(ENDPOINTS.TOP_TRADERS);

      return data
    } catch (error) {
      resolveRequestError(error);
    }
  }
  // ============== FUNCTION TO LOAD COUNTRIES ============
  static async loadCountries() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.COUNTRIES);
      return data;
    } catch (error) {
      resolveRequestError(error);
    }
  }

  // ========== FUNCTION TO CREATE STORES ==============
  static async createStores({ name, icon, logo }) {
    try {
      const { data } = await Vue.http.post(ENDPOINTS.STORES, {
        name,
        icon,
        logo,
      });
      return data;
    } catch (error) {
      resolveRequestError(error);
    }
  }

  // ============== FUNCTION TO EDIT STORES ============
  static async editStores(payload) {
    try {
      const { data } = await Vue.http.patch(ENDPOINTS.STORES, payload);
      return data;
    } catch (error) {
      resolveRequestError(error);
    }
  }

  // ============= FUNCTION TO GET STORES ================
  static async getStores() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.STORES);
      return data;
    } catch (error) {
      resolveRequestError(error);
    }
  }

  //    ================= FUNCTION TO GET CATEGORIES ============
  static async getCategories() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.CATEGORIES);
      return data;
    } catch (error) {
      resolveRequestError(error);
    }
  }

  // ==================== FUNCTION TO CREATE CATEGORIES ==========
  static async createCategories({ name, country, type, min, max }) {
    try {
      const { data } = await Vue.http.post(ENDPOINTS.CATEGORIES, {
        name,
        country,
        type,
        min,
        max,
      });
      return data;
    } catch (error) {
      resolveRequestError(error);
    }
  }

  // ================ FUNCTION TO EDIT CATEGORIES =============
  static async editCategories(payload) {
    try {
      const { data } = await Vue.http.patch(ENDPOINTS.CATEGORIES, payload);
      return data;
    } catch (error) {
      resolveRequestError(error);
    }
  }

  // ============= FUNCTION TO CREATE GIFTCARD =============
  static async createGiftcard({ store, icon, name, rate, country, type, min, max, cardMin, cardMax }) {
    try {
      const { data } = await Vue.http.post(ENDPOINTS.STOREGIFTCARD, {
        store,
        icon,
        name,
        rate,
        country,
        type,
        min,
        max,
        cardMin,
        cardMax,
      });
      return data;
    } catch (error) {
      resolveRequestError(error);
    }
  }

  static async deleteGiftcard(payload) {
    try {
      const { data } = await Vue.http.delete(`${ENDPOINTS.STOREGIFTCARD}/${payload.id} `);
      return data;
    } catch (error) {
      resolveRequestError(error);
    }
  }

  // ============== FUNCTION TO EDIT GIFTCARD ============
  static async editGiftcard(payload) {
    try {
      const { data } = await Vue.http.patch(ENDPOINTS.STOREGIFTCARD + `/${payload.id}`, payload);
      return data;
    } catch (error) {
      resolveRequestError(error);
    }
  }

  // ============ FUNCTION TO LOAD GIFTCARDS IN STORES =============
  static async loadGiftcards({ store }) {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.STOREGIFTCARD + `/${store}`);
      return data;
    } catch (error) {
      resolveRequestError(error);
    }
  }

  // ==================== FUNCTION TO LOAD GIFTCARD TRADES ================
  static async loadTrades({ page, limit, filters }) {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.TRADE, {
        params: {
          filters,
          page,
          limit,
        },
      });
      return data;
    } catch (error) {
      resolveRequestError(error);
    }
  }

  // ================= FUNCTION TO MATCH A LOADER TO A TRADER =================
  static async matchTrade({ trade, loader }) {
    try {
      const { data } = await Vue.http.patch(ENDPOINTS.TRADE + `/loaders`, {
        trade,
        loader,
      });
      return data;
    } catch (error) {
      resolveRequestError(error);
    }
  }

  // =============== FUNCTION TO EDIT GIFT CARD TRADE =============
  static async editTrade(payload) {
    try {
      const { data } = await Vue.http.patch(ENDPOINTS.TRADE + `/edit`, payload);
      app.$store.dispatch('toast', {
        message: 'Gift card transaction edited successfully',
        variant: 'success',
      });
      return data;
    } catch (error) {
      resolveRequestError(error);
    }
  }

  // ================== FUNCTION TO CLOSE GIFT CARD TRADE ==================
  static async closeTrade({ trade, action, reason, vendor }) {
    try {
      const { data } = await Vue.http.patch(ENDPOINTS.TRADE + `/close`, {
        trade,
        action,
        reason,
        vendor,
      });
      let message;
      if (action == CloseTradeEnum.ACCEPT) {
        message = 'Gift card transaction Approved';
      } else if (action == CloseTradeEnum.REJECT) {
        message = 'Gift card transaction Reject';
      }
      app.$store.dispatch('toast', {
        message: message,
        variant: 'success',
      });
      return data;
    } catch (error) {
      resolveRequestError(error);
    }
  }

  static async loadGiftcardVendors() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.VENDORS);
      return data;
    } catch (error) {
      resolveRequestError(error);
    }
  }

  // ================== SUSPEND ADMIN ==================
  static async suspendAdmin(email) {
    try {
      const { data } = await Vue.http.put(ENDPOINTS.ADMIN + `/suspend`, {
        email,
      });
      return data;
    } catch (error) {
      resolveRequestError(error);
    }
  }

  // ================== ACTIVATE ADMIN ==================
  static async activateAdmin(email) {
    try {
      const { data } = await Vue.http.put(ENDPOINTS.ADMIN + `/activate`, {
        email,
      });
      return data;
    } catch (error) {
      resolveRequestError(error);
    }
  }

  // ================== DELETE ADMIN ==================
  static async deleteAdmin(email) {
    try {
      const { data } = await Vue.http.delete(ENDPOINTS.ADMIN, {
        params: {
          email
        },
      });
      return data;
    } catch (error) {
      resolveRequestError(error);
    }
  }

  //==================== RESET ADMIN PIN ===================
  static async resetAdminPin(email){
    try {
      const { data } = await Vue.http.put(ENDPOINTS.RESET_ADMIN_PIN, {
        email,
      });
      return data;
    } catch (error) {
      resolveRequestError(error);
    }
  }


  static async getAllTutorials() {

    try {
      const { data } = await Vue.http.get(ENDPOINTS.TUTORIALS);
      if (data.status == 200) {
        return data.data;
      }
      else {
        return []
      }

    } catch (error) {
      resolveRequestError(error);
    }
  }

  // ============ GET PIN  STATUS =================
  static async pinStatus() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.RETRIEVE_PIN);
      return data;
    } catch (error) {
      resolveRequestError(error)
    }
  }
}

// TODO
// 1.) Request for success message from backend
